import {
  Card,
  CardHeader,
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableRow,
  TableBody,
  Tooltip,
  Paper,
  IconButton,
  TextField,
  InputAdornment,
  Typography,
  CircularProgress,
  Select,
  MenuItem,
  Stack,
  Chip,
} from '@mui/material'

export default function BillingRawValuesTable(props) {
  let { isUtil, devices, fullData, m, y, d } = props

  function isNumeric(str) {
    if (typeof str != 'string') return false
    return !isNaN(str) && !isNaN(parseFloat(str))
  }

  function sanitizeValue(v) {
    if (isNumeric(v.toString())) {
      v = parseFloat(v + '')
        .toFixed(3)
        .toString()

      if (v.endsWith('.000')) {
        v = v.split('.')[0]
      }

      //do twice since could end with '0' or '00' after the decimal
      if (v.includes('.') && v.endsWith(0)) {
        v = v.substring(0, v.length - 1)
      }
      if (v.includes('.') && v.endsWith(0)) {
        v = v.substring(0, v.length - 1)
      }
    }
    return v
  }

  return (
    <>
      <h3>{isUtil ? 'Utility (KWH)' : 'Generator (KWH)'}</h3>

      <TableContainer
        sx={{
          width: '100%',
          overflowX: 'auto',
          maxHeight: '80vh',
        }}
        component={Paper}
      >
        <Table stickyHeader aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ backgroundColor: '#F0F0F0' }}>
                <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                  Time
                </Typography>
              </TableCell>
              {devices &&
                devices.map((device) => (
                  <TableCell key={device} align="center" sx={{ backgroundColor: '#F0F0F0' }}>
                    <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                      {device}
                    </Typography>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {fullData.map((row, i) => (
              <TableRow key={i}>
                {row.map((v, j) => (
                  <TableCell key={'c' + j} align="center">
                    <Typography variant="caption">{sanitizeValue(v)}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}
